import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import production from "../views/production";
import prospection from "../views/prospection";
import encaissement from "../views/encaissement";
import statistique from "../views/statistique";
import sinistre from "../views/sinistre";
import inventaire from "../views/inventaire";
import echeance from "../views/echeance";
import cotation from "../views/cotation";
import couriers from "../views/courrier";
import contrat from "../views/contrat";
import payement from "../views/payement";
import Facture from "../views/facture";
import Mobile from "../views/mobile";
import Reversement from "../views/reversement"
import Rapprochement from "../views/rapprochement"
// import login from '../login'
//import App from '../App.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "loginApp",
    component: () => import("@/views/Login"),
    beforeEnter(to, from, next) {
      const user = localStorage.getItem("user-token");
      const admin = localStorage.getItem("admin-token");

      // student
      if (user || admin) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/",
    name: "Dashboard",
    component: () => import("@/layouts/Dashboard"),
    beforeEnter(to, from, next) {
      const user = localStorage.getItem("user-token");
      const admin = localStorage.getItem("admin-token");

      // student
      if (user || admin) {
        next();
      } else {
        next("/login");
      }
    },
    children: [
      {
        path: "/",
        name: "Dash",
        component: Home,
      },
      {
        path: "/management",
        name: "Management",
        component: () => import("@/views/management"),
      },
      {
        path: "/prospection/:id",
        name: "User more",
        component: () => import("@/views/userProspection"),
      },
      {
        path: "/contrat/:id",
        name: "User more",
        component: () => import("@/views/userContrat"),
      },
      {
        path: "/cotation/:id",
        name: "User more",
        component: () => import("@/views/usercotation"),
      },
      {
        path: "/sinistre/:id",
        name: "User more",
        component: () => import("@/views/userSinistre"),
      },

      {
        path: "/prospection",
        name: "prospection",
        component: prospection,
      },
      {
        path: "/contrat",
        name: "contrat",
        component: contrat,
      },
      {
        path: "/reversement",
        name: "Reversement",
        component: Reversement,
      },
      {
        path: "/facture",
        name: "Facture",
        component: Facture,
      },
      {
        path: "/cotation",
        name: "cotation",
        component: cotation,
      },
      {
        path: "/rapprochement",
        name: "Rapprochement",
        component: Rapprochement,
      },
      {
        path: "/courier",
        name: "couriers",
        component: couriers,
      },
      {
        path: "/sinistre",
        name: "sinistre",
        component: sinistre,
      },
      {
        path: "/mobile",
        name: "mobile",
        component: Mobile,
      },
      {
        path: "/inventaire",
        name: "inventaire",
        component: inventaire,
      },
      {
        path: "/production",
        name: "production",
        component: production,
      },
      {
        path: "/encaissement",
        name: "encaissement",
        component: encaissement,
      },
      {
        path: "/chart",
        name: "Statistique",
        component: statistique,
      },
      {
        path: "/payement",
        name: "payement",
        component: payement,
      },
      {
        path: "/echeance",
        name: "echeance",
        component: echeance,
      },
    ],
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
